import React from "react";
import { commercial_val_data } from "../../data/valuationData";
import { NavLink } from "react-router-dom";
import { PiPlayCircleLight } from "react-icons/pi";

const CommercialValuationPage = () => {
  return (
    <div className="px-[5vw] sm:px-[10vw] xl:px-[15vw] flex flex-col items-center sm:flex-row pt-[120px] gap-5">
      <div className="h-auto">
        <h1 className="py-2 text-2xl lg:text-3xl font-playfair">
          {commercial_val_data.title}
        </h1>
        <div className="py-5 flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-20">
          <div className="w-full lg:w-1/2 ">
            <img
              src={commercial_val_data.image_url}
              alt=""
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="w-full lg:w-1/2 space-y-5">
            <p>{commercial_val_data.description}</p>
            <p>{commercial_val_data.para}</p>
            <div className="space-y-2">
              {commercial_val_data.list_data.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-start items-center gap-1 cursor-pointer hover:text-yellow"
                >
                  <PiPlayCircleLight className="text-[20px]" />{" "}
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <p>{commercial_val_data.para1}</p>
            <p>{commercial_val_data.para2}</p>

            <p>
              Please{" "}
              <NavLink to="/contact-us" className="text-yellow">
                contact us{" "}
              </NavLink>
              for a guaranteed competitive quote.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommercialValuationPage;
